<template>
  <div class="relative flex items-start">
    <div class="flex h-5 items-center">
      <input
        :value="true"
        :name="name"
        type="checkbox"
        class="border-background-fg/30 text-primary focus:ring-primary h-6 w-6 rounded"
        :checked="checked"
        @change="handleChange"
      />
    </div>
    <div class="ml-3 text-sm">
      <label
        :for="name"
        class="text-background-fg/70 font-medium"
      >
        {{ label }}
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = defineProps<{
  label?: string
  name: string
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void
}>()

const { checked, handleChange } = useField(
  toRef(props, "name"),
  undefined,
  {
    type: "checkbox",
    checkedValue: true,
    uncheckedValue: false,
  }
)
</script>
